import * as S from '../styled';
import ItemIcon from '../ItemIcon';

interface Props {
  to: string,
  name: string
  icon?: string,
  level: number,
  badge?: string
  isOpen: boolean
  isFolder?: boolean
  requiresPremium?: boolean
  onClick?: { (e: any): void }
  hasChild: boolean
  setOpen: { (isOpen: boolean): void }
}

const Link = ({
  to,
  icon,
  name,
  level,
  badge,
  isOpen,
  isFolder,
  hasChild,
  requiresPremium,
  onClick,
  setOpen,
}: Props) => (
  <S.StyledLink
    to={to}
    isopen={isOpen ? 1 : 0}
    onClick={onClick}
    style={{
      paddingLeft: level > 1 ? (level * 28) - 14 : 14,
    }}
  >
    <ItemIcon
      icon={icon as any}
      level={level}
      isFolder={isFolder}
    />
    <S.Name>{name}</S.Name>
    {badge && <S.Badge>{badge}</S.Badge>}

    {requiresPremium && (
      <S.PremiumLock />
    )}

    {hasChild && (
      <S.Arrow
        isOpen={isOpen}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!isOpen);
        }}
      />
    )}
  </S.StyledLink>
);

export default Link;
